var MinimalTheme = {};

/* Custom Title Creation */
function isValidTitle(str) {
  // Ensure that title only include numbers and letters
  var regex = new RegExp(/^[A-Za-z0-9 _]*[A-Za-z0-9][A-Za-z0-9 _]*$/g);
  return regex.test(str);
}

function createTitleBadgeUrl(str) {
  var title = str.trim();
  if (!isValidTitle(title)) {
    return {
      state: 'invalid',
      message: 'Invalid title',
    };
  }

  var chars = title.length;

  if (chars > 40) {
    return {
      state: 'invalid',
      message: 'Title too long (40 characters max)',
    };
  }

  if (chars === 0) {
    return {
      state: 'invalid',
      message: 'Please enter a title',
    };
  }

  if (chars >= 31 && chars <= 40) {
    return {
      state: 'valid',
      message: '/products/custom-tb-31-40',
    };
  }

  if (chars >= 25 && chars <= 30) {
    return {
      state: 'valid',
      message: '/products/custom-tb-25-30',
    };
  }

  if (chars >= 21 && chars <= 24) {
    return {
      state: 'valid',
      message: '/products/custom-tb-21-24',
    };
  }

  if (chars === 19 || chars === 20) {
    return {
      state: 'valid',
      message: '/products/custom-tb-19-20',
    };
  }

  if (chars === 18) {
    return {
      state: 'valid',
      message: '/products/custom-tb-18',
    };
  }

  if (chars < 18) {
    return {
      state: 'valid',
      message: '/products/custom-title-badge',
    };
  }
}

function createBadgeBtnHandler() {
  var customTitleInput = document.getElementById('custom-title');
  var newName = customTitleInput.value.trim();
  var titleUrl = createTitleBadgeUrl(newName);
  var encoded = encodeURIComponent(newName.toUpperCase());
  if (titleUrl.state !== 'invalid') {
    window.location.replace('https://www.capitalbadges.co.uk' + titleUrl.message + '?title=' + encoded);
  }
}

var createBadgeBtn = document.querySelector('.titleSearch .createBadge');
if (createBadgeBtn !== null && createBadgeBtn !== undefined) {
  createBadgeBtn.addEventListener('click', createBadgeBtnHandler);
}

/* END Custom Title Creation */

/* SEARCH */
function toggleSearch(el, mobile) {
  if (mobile === undefined || mobile === null) {
    mobile = false;
  }

  if (mobile) {
    toggleNav();
    document.querySelector('.site-navigation__mobile .search_box').focus();
  } else {
    var form = el.closest('form');
    var input = form.querySelector('input.search_box');
    if(input.classList.contains('active')) {
      input.classList.remove('active');
    } else {
      input.classList.add('active');
      input.focus();
    }
  }
}
/* END SEARCH */

/* NAVGIATION */
function toggleNav() {
  var body = document.querySelector('body');
  if(body.classList.contains('nav-active')) {
    body.classList.remove('nav-active');
    document.querySelector('.mobile-nav-btn a').focus();
  } else {
    body.classList.add('nav-active');
    document.querySelector('.site-navigation__mobile .close-button').focus();
  }
}
/* END NAVGIATION */

/* POPOVER */
function activatePopover(activator) {
  var popover = activator.closest('.popover');
  popover.classList.add('active');
}

function deactivatePopover(popover) {
  if(!!popover) {
    popover.classList.remove('active');
  }
}

function outsidePopover(event) {
  if (event.target.closest('.popover')) return;
  if (event.target.closest('.popover__content')) return;
  if (event.target.closest('.popover__content .menu li')) return;
  var popovers = document.querySelectorAll('.popover.active');
  for(var i = 0; i < popovers.length; i++) {
    var popover = popovers[i];
    deactivatePopover(popover);
  }
}

document.addEventListener('click', outsidePopover);
/* END POPOVER */

function debounce(func, wait, immediate) {
	var timeout;
	return function() {
		var context = this, args = arguments;
		var later = function() {
			timeout = null;
			if (!immediate) func.apply(context, args);
		};
		var callNow = immediate && !timeout;
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
		if (callNow) func.apply(context, args);
	};
};

jQuery(window).ready(function(){
  
    $('.flexslider').flexslider({
      animation: "slide",
      slideshow: true,
      animationDuration: 700,
      slideshowSpeed: 8000,
      animation: "fade",
      prevText: "",
      nextText: "",
      keyboardNav: true
    }).hover(function(){ $('.flex-direction-nav').fadeIn();}, function(){$('.flex-direction-nav').fadeOut();});
  
});

jQuery(window).on('load',function(){  
  $("select.loc_on_change").change(function(){
    if($(this).find(":selected").attr("value") == "#") return false;
    window.location = $(this).find(":selected").attr("value");
  });
});

function checkMOQ() {
  update = true;
  if (jQuery('.item-quantity.limit').length > 0) {
    jQuery('.item-quantity.limit').each(function() {
      if (jQuery(this).val() < 10) {
        update = false;
        jQuery(this).closest('tr').find('td').css('background', '#EBCECD');
        if (jQuery(this).closest('tr').find('.item').find('.moqWarning').length == 0) {
          jQuery(this).closest('tr').find('.item').append('<br><span class="moqWarning" style="color:red;">Minimum value must be 10</span>');
        }
      }
    });
    if(update == false) {
      event.preventDefault();
    }
  }
}
jQuery(document).ready(function($){
  $('#update-cart').click(function() {
    checkMOQ();
  });
  $('#checkout-button').click(function() {
    if (jQuery('.item-quantity.limit').length > 0) {
      jQuery('.item-quantity.limit').each(function() {
        if (jQuery(this).val() < 10) {
          jQuery(this).closest('tr').find('td').css('background', '#EBCECD');
          if (jQuery(this).closest('tr').find('.item').find('.moqWarning').length == 0) {
            jQuery(this).closest('tr').find('.item').append('<br><span class="moqWarning" style="color:red;">Minimum value must be 10</span>');
          }
        }  else {
          $('#checkout').removeAttr('disabled').click();
        }
      });
    } else {
      $('#checkout').removeAttr('disabled').click();
    }
  });


  // REPLACE THIS?           
  $('#custom-title').keypress(function(event){
    if (event.keyCode == 10 || event.keyCode == 13) 
        event.preventDefault();
  });
  // END REPLACE THIS?

  // force wide nav -->  
  
  // <-- end force wide nav
  
  $(".flyout").hide();

  $("#menu-button").on("click", function() {
    $(".flyout").slideToggle( "fast" );
  });

  $(".sub-menu").hide();
  $(".more, .account-links").on("click", function() {
    $(this).parent().nextAll("ul").slideToggle( "fast" );
    $("i", this).toggleClass("fa-plus fa-minus");
    $(this).next(".more").find("i").toggleClass("fa-user fa-minus");
  });  

  $("nav.mobile select").change(function(){ window.location = jQuery(this).val(); });
   
  
    /* Initialize zoom on main product image */
    var mainProductImage = $('.image.featured img');
    if (mainProductImage.length) {
      var zoomedSrc = mainProductImage.attr('src').replace('_1024x1024', '');
      mainProductImage
        .css('display', 'block')
        .parent()
        .zoom( { url: zoomedSrc } );
    }
  
  
  MinimalTheme.switchImage = function(newSizedImageSrc, newImage, mainImageDomEl) {
    var largestImage = newSizedImageSrc.replace('_1024x1024', '');
    $(mainImageDomEl)
      .attr('src', newSizedImageSrc)
      .parents('a')
      .attr('href', largestImage);
    
    $(mainImageDomEl)
      .parent()
      .trigger('zoom.destroy')
      .zoom( { url: largestImage } );
    
  };
  
  $('#product .thumbs a').click(function(e){
    e.preventDefault();
    var newSizedImageSrc = $(this).attr('href');
    var mainImageDomEl = $('.image.featured img')[0];
    MinimalTheme.switchImage(newSizedImageSrc, null, mainImageDomEl);
  });
  
  $('input[type="submit"], input.btn, button').click(function(){ // remove ugly outline on input button click
    $(this).blur();
  })
  
  $('li.dropdown').hover(function(){
    $(this).children('.dropdown').show();
    $(this).children('.dropdown').stop();
    $(this).children('.dropdown').animate({
      opacity: 1.0
    }, 200);
  }, function(){
    $(this).children('.dropdown').stop();
    $(this).children('.dropdown').animate({
      opacity: 0.0
    }, 400, function(){
      $(this).hide();
    });
  });
  
});